import React, { Fragment } from "react";
import { withStyles } from "@material-ui/core";
// import Lottie from "lottie-react";
// import DataContext from "../../data/DataContext";
import Carousel from "../../carousel/Carousel";

const styles = theme => ({
    root: {
      display: "flex",
      flexDirection: "column"
    },
    leftContainer: {
      justifyContent: "flex-start",
      // maxWidth:"75%"
    },
    rightContainer: {
      justifyContent: "flex-end"
    },
    leftMessage: {
      // backgroundColor: "white",
      // boxShadow: "0px 12px 12px rgba(194, 194, 194, 0.58)",
      // fontWeight: "300",
    },
    rightMessage: {
      // backgroundColor: theme.color.message.background,
      // margin: "8px 10px",
      boxShadow: "none"
    },
    message: {
      fontSize: theme.font.size15, // "15px",
      borderRadius: "12px",
      flexWrap: "wrap",
      color: theme.color.message.color,
      padding: "2px 16px 3px",
      maxWidth: "75%",
      zIndex: 10,
      wordWrap: 'break-word',
      wordBreak: "break-word"
    },
    text: {
      padding: "12px 16px",
      lineHeight: "1.43",
      borderRadius: "10px",
      backgroundColor: theme.color.message.background,
      fontFamily: "inherit",
      fontSize: "14px",
      fontWeight: "normal",
      fontStretch: "normal",
      fontStyle: "normal",
      letterSpacing: "normal",
      textAlign: "left",
      color: theme.color.message.color,
    },

    buttonWrapper:{
      padding: "0px 3px"
    },
    button:{
      // minWidth: "100%",
      // border: "1px solid red",
      margin: "0",
      border: "0",
      borderRadius: "6px",
      boxShadow: "0 2px 6px 0 rgba(0, 0, 0, 0.1)",
      backgroundColor: "#fff",
      display: "flex",
      // justifyContent: "center",
      alignItems: "center",
      height: "64px",
    },

    buttonIcon:{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    }, 
    buttonLabel:{
      fontFamily: "inherit",
      fontSize: "14px",
      fontWeight: "500",
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "1.29",
      letterSpacing: "normal",
      textAlign: "left",
      color: "#000",
      paddingRight: "5px",
      minWidth: "max-content",
    },
    menuIcon:{
      width: "40px",
      height: "40px",
      marginRignt: "6px"
    },
   
    title:{
      padding: "12px 0px 6px 0px",
      fontFamily: "inherit",
      fontSize: "15px",
      fontWeight: "bold",
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "1.2",
      letterSpacing: "normal",
      textAlign: "left",
      color: "#000",
    },
   
    
   
  });

const SGButton  = withStyles(styles)((props)=>{
    const { classes, data } = props;
    // const [buttonVisible, setButtonVisible] = useState(true);
    // const context = useContext(DataContext);
    const handleClick = (button) => {
        // setButtonVisible(false);
        // context.request(context, button.label, "button");
    };
    return data.buttons.map((button, key) =>
        // buttonVisible && (
          <div className={classes.buttonWrapper} key={`key-${key}`}>
              <button
                className={classes.button}
                onClick={() => handleClick(button)}
                tabIndex={1}
                aria-label={`${button.label}, ${key + 1} / ${data.buttons.length}`}
              >
                <div className={classes.buttonIcon}>
                    {button.icon_code && <img src={`/image/${button.icon_code}.svg`} className={classes.menuIcon}/>}
                </div>
                <div className={classes.buttonLabel}>{button.label}</div>
              </button>
          </div>
          
        // )
    )
    });
function SGICHorizontal(props) {
    const { classes, data } = props;
    return (
        <Fragment>
            <div
                className={[
                classes.root,
                data.mine ? classes.rightContainer : classes.leftContainer
                ].join(" ")}
            >
                <div
                    className={[
                    classes.message,
                    data.mine ? classes.rightMessage : classes.leftMessage,
                    ].join(" ")}
                    >
                    
                    {data.text && data.text.length &&(
                      <div role={"text"} className={classes.text}>
                          {data.text.split("\n").map((content, key) => (
                              <Fragment key={key}>
                              {content}
                              <br />
                              </Fragment>
                          ))}
                      </div>
                      )}
                      {data.title && data.title.length &&(
                        <div className={classes.title}>
                          {data.title}
                        </div>
                      )}
                </div>
            </div>
            
            <Carousel
            component = {withStyles(styles)(SGButton)} 
            data={data}
            indicator={true}/>
            
        </Fragment>
      );
}
export default withStyles(styles)(SGICHorizontal);
    